import React from "react";
import Collapsible from "react-collapsible";

const DetailsModal = (props) => {
  const handleTrigger = () => {
    document.getElementById("view-all").click();
    document.getElementById("view-all-btn").style.display = "none";
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const displaySkills = () => {
    let ParentArray = [];
    props.Job.requiredSkills.map((Item) => {
      ParentArray.push(Item.title);
    });
    let Skills = [...ParentArray];
    let Top10 = [...ParentArray].splice(0, 10);
    let OtherSkills = [...ParentArray].splice(10, Skills.length);
    return (
      <section className="all-skills">
        {Top10.map((Skill) => (
          <React.Fragment>
            <div className="skill-item">{Skill}</div>
          </React.Fragment>
        ))}
        {props.Job.requiredSkills.length > 10 ? (
          <p
            className="view-all"
            id="view-all-btn"
            onClick={() => handleTrigger()}
          >
            {translateText("view_all")} <i className="feather-chevron-down"></i>
          </p>
        ) : null}
        <Collapsible
          transitionTime={200}
          trigger={<p id="view-all" hidden></p>}
        >
          <React.Fragment>
            {OtherSkills.map((Skill) => (
              <div className="skill-item">{Skill}</div>
            ))}
          </React.Fragment>
        </Collapsible>
      </section>
    );
  };
  return (
    <div className="modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="modal-body">
        <section className="modal-head">
          <p className="job-title">{props.Job.project.title}</p>
          <p className="job-location">{props.Job.project.workCity}</p>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="modal-content">
          <h1 className="content-title">
            {translateText("all_required_skills") +
              " (" +
              props.Job.requiredSkills.length +
              ")"}
          </h1>
          {displaySkills()}
        </section>
      </div>
    </div>
  );
};

export default DetailsModal;
